export default class Favorite {

    constructor(id, params, result, options) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        this.cssClass = 'is-favorite'

        this.init()
    }

    init() {
        this.addObservers()
        this.initProductList()
    }

    reInit() {
        this.initProductList()
    }

    addObservers() {
        let self = this

        this.$component.on('click', '.js-basket-item-favorite', async function (e) {
            // console.log('js-basket-item-favorite - obs - click')
            await self.change(this.closest('.js-item'))
        })
    }

    async change(item) {
        // console.log('Favorite -> change - start')
        try {
            let postData = {
                H2O_FAVORITES_ELEMENT_ID: this.getIdByItem(item),
                h2o_add_favorites: 'Y',
            }

            const cleanUrl = `${window.location.origin}${window.location.pathname}?AJAX_CALL_FAVORITES_ADD=Y`
            const result = await Endorphine.Api.query(cleanUrl, postData)

            if ('ADD' in result) {
                this.add(item)
            } else if ('DELETE' in result) {
                this.del(item)
            }
        } catch (error) {
            console.error(error)
        }
    }

    add(item) {
        item.classList.add(this.cssClass)

        if (window.h2oFavoritAdd && Array.isArray(window.h2oFavoritAdd.currentFavorites)) {
            let id = Number.parseInt(this.getIdByItem(item))

            window.h2oFavoritAdd.currentFavorites.push(id)
        }
    }

    del(item) {
        item.classList.remove(this.cssClass)

        if (window.h2oFavoritAdd && Array.isArray(window.h2oFavoritAdd.currentFavorites)) {
            let id = Number.parseInt(this.getIdByItem(item))

            window.h2oFavoritAdd.currentFavorites = window.h2oFavoritAdd.currentFavorites.filter(
                item => Number.parseInt(item) !== id
            )
        }
    }

    initProductList() {
        if (!window.h2oFavoritAdd || !Array.isArray(window.h2oFavoritAdd.currentFavorites)) {
            return
        }

        for (const id of window.h2oFavoritAdd.currentFavorites) {
            let block = this.$component.querySelector(`.js-item-id-${id}`)
            let blockParent = this.$component.querySelector(`.js-item-parent-id-${id}`)

            if (!block && !blockParent) {
                continue
            }

            if (block) {
                block.classList.add(this.cssClass)
            }
            if (blockParent) {
                blockParent.classList.add(this.cssClass)
            }
        }
    }

    getIdByItem(item) {
        let productId = Number.parseInt(item.getAttribute('data-product-id')),
            parentId = Number.parseInt(item.getAttribute('data-product-id'))

        return 0 < parentId ? parentId : productId
    }
}
